import { TbSparkles } from 'react-icons/tb'
import { P } from '~/components-v2'
import {
  CompareGrid,
  CompareItem,
  CompareQuote,
  ComparisonCard,
  OmniLogo,
  StrategyLogo,
} from '~/components-v2/compete-comparison-card'

export const CompareCard1 = () => {
  return (
    <ComparisonCard
      className="icon-pink"
      icon={<TbSparkles />}
      title="Keep your governance. Change how fast it moves."
      subhead="Strategy’s semantic layer is why many teams picked it. Omni keeps that idea and makes it flexible: build logic as you go, reuse definitions from other tools, and give experts safe promotion paths from the UI, all version-controlled in Git."
    >
      <CompareGrid
        id="omni-governance"
        compareLogos={[<OmniLogo key={1} />, <StrategyLogo key={2} />]}
        compareItems={[
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Start fast without giving up control.</strong> A schema
                layer mirrors the warehouse, a shared layer holds governed
                metrics, and workbooks hold ad-hoc work. Metrics that earn trust
                get{' '}
                <a
                  href="https://docs.omni.co/modeling"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  promoted into the shared model
                </a>
                .
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Rigid data structures.</strong> Every change, new
                report, or definition update has to queue up behind data
                engineers and cube specialists.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Manage model changes like software.</strong> The shared
                model{' '}
                <a
                  href="https://docs.omni.co/integrations/git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  syncs to Git
                </a>
                : review in pull requests, test on a branch, roll back
                instantly. When a definition stops changing, move it into your
                warehouse or <a href="https://omni.co/dbt">dbt</a>.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Change implementation is slow.</strong> Moving work from
                test to production runs through a separate migration service. No
                branches, pull requests, or Git.
              </P>
            </CompareItem>,
          ],
        ]}
      />

      <CompareGrid
        id="omni-governance-quote-1"
        oneColumn={true}
        compareItems={[
          [
            <CompareQuote
              key={1}
              type="positive"
              linkURL="https://www.g2.com/products/omni-analytics-inc-omni-analytics/reviews/omni-analytics-review-11339800"
              linkLabel="Omni customer"
              quote={
                <p>
                  Omni’s two-way integration with dbt has been a game changer.
                  [...] Whether we are using our dbt models or building
                  something fast in Omni, we can push the results back to our
                  data warehouse with ease.
                </p>
              }
            />,
          ],
        ]}
      />

      <CompareGrid
        id="omni-governance-continued"
        compareItems={[
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>
                  Governance is enforced in the model and AI harness.
                </strong>{' '}
                <a
                  href="https://docs.omni.co/modeling/develop/data-access-control"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Access grants and filters
                </a>{' '}
                control everything from entire datasets down to individual rows,{' '}
                <a
                  href="https://docs.omni.co/administration/users/attributes"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  applied automatically
                </a>{' '}
                from each user&apos;s attributes. The{' '}
                <a
                  href="https://omni.co/blog/benchmarking-omnis-agentic-analytics-harness"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  harness
                </a>{' '}
                applies those same controls to every AI question.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Security is defined per project.</strong> Filters live
                at the project level, so each project carries its own. What you
                grant one business unit doesn&apos;t follow a user to the next.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>
                  Reuse and extend the core model for business units and
                  customers.
                </strong>{' '}
                Shared extension models inherit joins,{' '}
                <a href="https://omni.co/blog/teach-ai-to-understand-your-business-with-omni-topics">
                  Topics
                </a>{' '}
                (curated datasets), and definitions from a parent. Users route
                to their own extension automatically by user attribute.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Nothing carries across projects.</strong> What you build
                for one business unit gets built again for the next, with no
                shared foundation between them.
              </P>
            </CompareItem>,
          ],
        ]}
      />

      <CompareGrid
        id="omni-governance-quote-2"
        oneColumn={true}
        compareItems={[
          [
            <CompareQuote
              key={1}
              type="positive"
              linkURL="https://www.g2.com/products/omni-analytics-inc-omni-analytics/reviews/omni-analytics-review-11510888"
              linkLabel="Omni customer"
              quote={
                <p>
                  Omni gives us the very sweet spot between providing good
                  governance for the data team to maintain some order within
                  metrics, but also enough flexibility to allow ad hoc versions
                  for users.
                </p>
              }
            />,
          ],
        ]}
      />
    </ComparisonCard>
  )
}
